import { styled } from 'styled-components';

const LeaderBoardPage = () => {
  return <Wrapper>Leaderboard</Wrapper>;
};

const Wrapper = styled.main``;

export { LeaderBoardPage };
